import React, { useState } from 'react'
import { Button, Input, Textarea, Spinner } from '@material-tailwind/react';

export default function UploadDetail({ cb, className, handleInputChange, type, maxLength, label, uploadEntry, uploadEntryValue }) {
  const [uploadEntryNewValue, setUploadEntryNewValue] = useState(uploadEntryValue || "");
  const [message, setMessage] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  function handleChange(uploadEntry, update) {
    setUploadEntryNewValue(update);
    if (uploadEntryValue === update || !update) {
      setMessage("");
      setDisabled(true);
      return;
    }

    const validationResult  = handleInputChange(uploadEntry, update);

    if (validationResult === true) {
      setMessage("");
      setDisabled(false);
    } else {
      setMessage(validationResult);
      setDisabled(true);
    }
  }

  async function handleSaveBtn(uploadEntry, update) {
    setDisabled(true);
    setLoading(true);
    const result = await cb(uploadEntry, update);
    
    setLoading(false);
    if (result.status === "success") {
      setSuccess(true);
      setTimeout(() => setSuccess(false), 2500)
    } else {
      setMessage(result.message);
    }
  }

  return (
    <div className={`${className || ""} flex flex-col mb-2`}>
      <span>{label}:</span>
      <div className={`${type === "input" ? "" : "items-end"} relative mt-1 flex flex-col w-full`}>
        <Textarea
          type="text"
          value={uploadEntryNewValue}
          onChange={(e) => handleChange(uploadEntry, e.target.value)}
          maxLength={maxLength}
          className={`${type === "textarea" ? "" : "hidden"} text-lg !border-blue-gray-200`}
          labelProps={{
            className: "before:content-none after:content-none",
          }}
          containerProps={{
            className: `${type === "textarea" ? "" : "!hidden"} !min-w-0`,
          }}
        />
        <Input
          type="text"
          value={uploadEntryNewValue}
          onChange={(e) => handleChange(uploadEntry, e.target.value)}
          maxLength={maxLength}
          className={` text-lg !border-blue-gray-200`}
          labelProps={{
            className: "before:content-none after:content-none",
          }}
          containerProps={{
            className: `${type === "input" ? "" : "!hidden"} !min-w-0`,
          }}
        />
        <div className={type === "input" ? '' : 'w-full flex flex-row-reverse justify-between'}>
          <Button
            onClick={() => handleSaveBtn(uploadEntry, uploadEntryNewValue)}
            size="sm"
            color={success ? "green" : "gray"}
            disabled={disabled}
            className={`${type === "input" ? "!absolute right-1 bottom-1" : "w-16"} rounded disabled:pointer-events-auto disabled:cursor-not-allowed flex justify-center`}
          >
            {success ? <i className='bx bx-check text-sm leading-none'></i> : loading ? <Spinner className='w-4 h-4' /> : "Save"}
          </Button>
          <span className={`${type === 'textarea' && message ? 'text-red-500' : 'hidden'} text-sm`}>{message}</span>
        </div>
      </div>
      <span className={`${type === 'input' && message ? 'text-red-500' : 'hidden'} text-sm`}>{message}</span> 
    </div>
  )
}
